import React from 'react';
import HotelsFiltersBar from './HotelsFiltersBar';
import HotelsTable from './HotelsTable';
import '../../stylesheets/hotels-content-list.scss';

const HotelsContentList = () => {
    return (
        <div className='hotels-content-list__page'>
            <HotelsFiltersBar />
            <div className='hotels-content-list__table'>
                <HotelsTable />
            </div>
        </div>
    );
};

export default HotelsContentList;
